module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch04"
    }
  }, [_c('b', [_vm._v("Talk Like a Pirate")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', [_c('b', [_vm._v("THREATS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_vm._v("Your sands are run!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(I’m going to kill you!)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("I’ll slit a couple of feet of steel into your vitals!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(I’ll stab you with my sword!)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("I come from hell, and I’ll carry you there presently.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(How all good pirates answer the question “Where are you from?”)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', [_c('b', [_vm._v("INSULTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_vm._v("You’re a dung-souled knuckle brain.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(You’re an incapable idiot.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("You’ve got a split tongue.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(You’re a liar.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("You should be fed on pap and suckets.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(You’re acting like a baby. Pap and suckets were soft foods often served to babies.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The smell of you alone is enough to wrinkle the noses of pigs.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(You stink.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', [_c('b', [_vm._v("GENERAL DIRECTIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_vm._v("“Scupper your hide out of here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_vm._v("("), _c('i', [_vm._v("Go away.")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Clap a stopper on your eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Quit crying.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Put a name on what you’re at.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(What do you mean?)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Bestir yourself!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Move it!)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Cough up your tale.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Tell us your story.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Keep your tongue behind your teeth.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Don’t say anything.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Shiver your timbers.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Wait a minute.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Stay your claws.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Keep your hands to yourself.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Strike your colors.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Surrender.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Cock your piece.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_c('i', [_vm._v("(Get your gun ready.)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba7a93e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter04.vue
// module id = 84
// module chunks = 0